var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisitReportDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17718_81619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5835 7.80512C4.5835 4.50702 7.45634 1.83337 11.0002 1.83337C14.544 1.83337 17.4168 4.50702 17.4168 7.80512C17.4168 11.0774 15.3688 14.8958 12.1736 16.2613C11.4287 16.5796 10.5716 16.5796 9.82677 16.2613C6.63147 14.8958 4.5835 11.0774 4.5835 7.80512Z",
    stroke: "#0D0D0D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8332 8.24996C12.8332 9.26248 12.0124 10.0833 10.9998 10.0833C9.98732 10.0833 9.1665 9.26248 9.1665 8.24996C9.1665 7.23744 9.98732 6.41663 10.9998 6.41663C12.0124 6.41663 12.8332 7.23744 12.8332 8.24996Z",
    stroke: "#0D0D0D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.214 14.2084C19.8239 14.7606 20.1668 15.3832 20.1668 16.0417C20.1668 18.3199 16.0628 20.1667 11.0002 20.1667C5.93755 20.1667 1.8335 18.3199 1.8335 16.0417C1.8335 15.3832 2.17644 14.7606 2.78634 14.2084",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17718_81619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitReportDark);
export default __webpack_public_path__ + "static/media/visit-report-dark.d534d8aa9876a920b859e603a85c7ce4.svg";
export { ForwardRef as ReactComponent };